export default __webpack_public_path__ + "static/media/tick.3b0f77d5.svg";